<app-hero
	[title]="'support.postBuy.title' | translate"
	imageDesktop="assets/hero/assistenza.jpg"
	imageMobile="assets/hero/assistenza_mobile.jpg"
/>
<div class="pt-5">
	<section class="container-xxl px-0">
		<div>
			<h3 class="fw-bold mb-2 text-blue text-huge">
				{{ "support.contacts.title" | translate }}
			</h3>
		</div>

		<div class="contact-container px-3 row row-cols-1 row-cols-lg-3 text-big">
			<div class="col py-4 text-lightblue">{{ "support.contacts.ourContacts" | translate }}</div>
			<div class="col py-4 lineBefore">
				<span class="d-flex align-items-middle">
					<span
						class="btn-ico btn-ico-email-before text-lightblue"
						[title]="'template.email' | translate"
					>
					</span>
					<strong class="ps-2">
						<a
							class="before-ico ico-mail text-basecolor"
							[href]="'mailto:' + ('footer-app-and-contacts.email' | translate)"
						>
							<span>{{ "footer-app-and-contacts.email" | translate }}</span>
						</a>
					</strong>
				</span>
			</div>
			<div class="col py-4 lineBefore">
				<span class="d-flex align-items-middle">
					<span
						class="btn-ico btn-ico-phone-before text-lightblue"
						[title]="'template.phone' | translate"
					>
					</span>
					<strong class="ps-2">
						<a
							class="before-ico ico-phone text-basecolor"
							[href]="'tel:' + ('footer-app-and-contacts.tel' | translate)"
						>
							<span>{{ "footer-app-and-contacts.tel" | translate }}</span>
						</a>
					</strong>
				</span>
			</div>
		</div>
		<p class="col py-4 text-lg my-0 border-bottom-gray">{{ "support.contacts.orSendRequest" | translate }}</p>
		<form
			[formGroup]="contactForm"
			(ngSubmit)="onSubmit()"
		>
			<fieldset class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 border-bottom-gray pt-3 pb-4">
				<div class="px-3">
					<label
						class="text-blue py-2"
						for="businessName"
					>
						{{ "userProfile.businessName" | translate }}</label
					>
					<br />
					<input
						id="businessName"
						formControlName="businessName"
						class="defaultInput w-100"
						type="text"
						readonly
					/>
				</div>
				<div class="px-3">
					<label
						class="text-blue py-2"
						for="city"
						>{{ "userProfile.city" | translate }}</label
					>
					<br />
					<input
						id="city"
						formControlName="city"
						class="defaultInput w-100"
						type="text"
						readonly
					/>
				</div>
				<div class="px-3">
					<label
						class="text-blue py-2"
						for="name"
						>{{ "user.name" | translate }}</label
					>
					<br />
					<input
						id="name"
						formControlName="name"
						class="defaultInput w-100"
						type="text"
						readonly
					/>
				</div>
				<div class="px-3">
					<label
						class="text-blue py-2"
						for="email"
						>{{ "userProfile.email" | translate }} *
					</label>
					<br />
					<input
						id="email"
						formControlName="email"
						class="defaultInput w-100"
						type="email"
					/>
				</div>
				<div class="px-3">
					<label
						class="text-blue py-2"
						for="tel"
						>{{ "userProfile.telephone" | translate }} *
					</label>
					<br />
					<input
						id="tel"
						formControlName="phone"
						class="defaultInput w-100"
						type="tel"
					/>
				</div>
				<div class="px-3">
					<label
						class="text-blue py-2"
						for="claim"
						>{{ "support.contacts.claimType" | translate }} *</label
					>
					<br />
					<select
						class="defaultInput w-100"
						id="claim"
						formControlName="claimType"
					>
						<option
							value=""
							selected
						>
							&mdash;
						</option>
						@for (opt of claimTypes; track opt.elementCode) {
							<option [value]="opt.elementCode">
								{{ opt.elementCode | clkBizCT: "CLAIM_TYPE" }}
							</option>
						}
					</select>
				</div>
				<div class="px-3">
					<label
						class="text-blue py-2"
						for="plate"
					>
						{{ "vehicle.licensePlate" | translate }} *
					</label>
					<br />
					<input
						id="plate"
						formControlName="licensePlate"
						class="defaultInput w-100"
						type="text"
					/>
				</div>
			</fieldset>
			<p class="col py-3 text-lg my-0">{{ "support.contacts.request" | translate }}</p>
			<fieldset class="pb-5">
				<div>
					<label
						class="text-blue py-2"
						for="message"
						>{{ "support.contacts.message" | translate }} *
					</label>
					<br />
					<textarea
						id="message"
						formControlName="message"
						class="defaultInput w-100 h-auto"
						rows="4"
					>
					</textarea>
				</div>
				<div class="py-3">
					<div>{{ "support.contacts.attachments" | translate }}</div>
					<label
						class="uploadfilecontainer"
						appDragDrop
						(onFileDropped)="fileChanged($event)"
					>
						<!-- [class.input-error]="showErrorUpVisura && registrationForm.controls.visura.invalid"  -->
						<input
							hidden
							type="file"
							multiple
							(change)="fileChanged($event.target.files)"
						/>
						<!-- accept="application/pdf" -->
					</label>
					@if (files.length) {
						@for (file of files; track file.name) {
							<div class="files-list my-3">
								<p>{{ file.name }}</p>
								<button
									class="delete-file"
									(click)="deleteAttachment($index)"
								>
									<img
										class="iconInputFile"
										[src]="wcmService.trashCircleUrl"
									/>
								</button>
							</div>
						}
					}
				</div>
				<div class="py-4 border-bottom-gray">
					<input
						type="checkbox"
						formControlName="checkConsents"
						id="consent"
					/>
					<span
						class="ps-2"
						[innerHTML]="'support.contacts.iAcceptTermsConditions' | translate"
					>
					</span>
				</div>
				<div class="text-end py-4">
					<button
						[disabled]="contactForm.invalid || dataSent"
						class="btn btn-red"
						type="submit"
					>
						{{ "support.contacts.sendRequest" | translate }}
					</button>
				</div>
			</fieldset>
		</form>
	</section>
</div>